import { render } from "./SprintDeleteMark.vue?vue&type=template&id=040de878&scoped=true"
import script from "./SprintDeleteMark.vue?vue&type=script&lang=js"
export * from "./SprintDeleteMark.vue?vue&type=script&lang=js"

import "./SprintDeleteMark.vue?vue&type=style&index=0&id=040de878&scoped=true&lang=css"

import exportComponent from "/home/runner/work/adx-front-end/adx-front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-040de878"]])

export default __exports__